import * as React from "react";

import { ProductDisplay } from "../../../components";
import { Product } from "../../../models";
import { TrackClick } from "../../../hoc";
import "./PriceItem.css";

interface PriceItemProps {
  chosenProduct: Product;
  onDesignClick: (e: any) => void;
}
const PriceItem = (props: PriceItemProps) => {
  return (
    <div className="price-item row">
      <div className="col-md-8 col-md-offset-2">
        <ProductDisplay {...props.chosenProduct} />
        <TrackClick
          category="landingpage"
          action="Clicked &quot;design&quot; call-to-action"
          label={props.chosenProduct.name}
          onClick={props.onDesignClick}
          render={handleClick => (
            <button
              className="price-item__call-to-action"
              onClick={handleClick}
            >
              Thiết kế ngay
            </button>
          )}
        />
      </div>
    </div>
  );
};

export default PriceItem;



// WEBPACK FOOTER //
// ./src/routes/Price/components/PriceItem.tsx